/* global __NXT_FRONT_CONFIG__ */
const NXTCMS_URL = __NXT_FRONT_CONFIG__.VUE_APP_NXTCMS_URL
const SANTE_URL =  __NXT_FRONT_CONFIG__.VUE_APP_SANTE_URL
const VIGEO_URL = __NXT_FRONT_CONFIG__.VUE_APP_VIGEO_URL

export {
    NXTCMS_URL,
    SANTE_URL,
    VIGEO_URL
}
